import { PRODUCT_OPTION_DETAILS } from 'cards/constants/productOptionDetails';
import { CARD_TYPES } from 'cards/constants/CardTypes';
import { CARD_SIZES } from 'cards/constants/Cards';
import { ORIENTATION } from 'cards/types';

type ProductDetailKey = keyof typeof PRODUCT_OPTION_DETAILS;

export const getProductOptionDetailsKey = (
  key: string,
  value: string,
  cardType: string,
  orientation: ORIENTATION
): ProductDetailKey => {
  if (key === 'size' && value === 'magnet') {
    return `size-magnet`;
  }

  if (key === 'size' && cardType === CARD_TYPES.menu) {
    return `menu-${value}` as ProductDetailKey;
  }

  if (value === CARD_SIZES.folded && orientation === ORIENTATION.portrait) {
    return 'folded-petite-portrait';
  }

  return value as ProductDetailKey;
};
